import { call, options } from './helpers';

export const getSettings = (payload) =>
	call(`/beta/settings`, options(payload, 'GET'));

export const updateSettings = (payload) =>
	call(`/beta/settings`, options(payload, 'POST'));
